module.exports = __webpack_public_path__ + "static/media/newsletter-june-2018-church-model.4b994aea.jpg";